import {connect} from 'react-redux';
import React, {Component} from 'react';

import ResultSearch from '../ResultSearch';
import Map from '../../../components/Base/Map';
import * as SearchConst from '../../../constants/Search';
import FiltersBlockVertical from './FiltersBlockVertical';
import FiltersBlockHorizontal from './FiltersBlockHorizontal';

class LeftBoxContentBuy extends Component {
    state = {
        maxScrollTop: 0
    };

    handleScroll = event => {
        const scrollTop = event.target.scrollTop;

        if (scrollTop < this.state.maxScrollTop) {
            let documentScrollTop = document.documentElement.scrollTop;
            if (documentScrollTop !== 0) {
                const delta = this.state.maxScrollTop - scrollTop;
                const newDocumentScrollTop = documentScrollTop - delta;
                if (newDocumentScrollTop < 0) {
                    document.documentElement.scrollTop = 0;
                } else {
                    document.documentElement.scrollTop = newDocumentScrollTop;
                }
            }
        }

        this.setState({
            maxScrollTop: scrollTop
        });
    };

    getSearchLink = () => {
        const {dateStart, dateEnd} = this.props;
        let response = '?';

        if (dateStart !== undefined) {
            response += `${SearchConst.REQUEST_PARAMS_NAMES.DATE_START}=${dateStart}&`;
        }
        if (dateEnd !== undefined) {
            response += `${SearchConst.REQUEST_PARAMS_NAMES.DATE_END}=${dateEnd}`;
        }
        return response;
    };

    render() {
        const {isGoogleApiInit, defaultLat, isHorizontalMode} = this.props;

        return (
            <div className="left_box_content renta2" onScroll={this.handleScroll}>
                <FiltersBlockVertical />
                <FiltersBlockHorizontal />

                {isGoogleApiInit && defaultLat !== undefined && isHorizontalMode && <Map
                    zoom={10}
                    id="map_from_content"
                    className="map_from_content"
                    searchLink={this.getSearchLink()}
                    objects={this.props.searchPage.searchResult.rows}
                    centerLng={this.props.searchPage.requestParams.centerLng}
                    centerLat={this.props.searchPage.requestParams.centerLat}
                />}

                <ResultSearch />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    searchPage: state.searchPage,
    defaultLat: state.configuration.main.defaultLat,
    dateEnd: state.searchPage.requestParams.dateEnd,
    isHorizontalMode: state.searchPage.isHorizontalMode,
    dateStart: state.searchPage.requestParams.dateStart,
    isGoogleApiInit: state.configuration.isGoogleApiInit
});

export default connect(mapStateToProps)(LeftBoxContentBuy);



// WEBPACK FOOTER //
// ./src/components/Search/Buy/LeftBoxContentBuy.js